module.exports = __webpack_public_path__ + "img/burst.ee7c7977.png";